import { Heading1 } from '@/components/common/Heading1.tsx';
import { Button } from '@/components/ui/button.tsx';

export default function InsuranceDiscoveryError({ onRetry }: { onRetry: () => void }) {
  return (
    <div
      className="flex flex-col items-center justify-center space-y-6"
      role="alert"
      aria-live="assertive"
      aria-describedby="insurance-check-error"
    >
      <Heading1 className="pb-0 text-center">Unable to look up your benefits</Heading1>

      <div className="flex flex-col items-center space-y-4">
        <p id="insurance-check-error" className="text-charcoal-500 text-center text-base">
          An error occurred while looking up your benefits. Please try again.
        </p>

        <Button onClick={onRetry} className="mt-4">
          Try Again
        </Button>
      </div>
    </div>
  );
}
